exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".team-thumb {\n  width: 48px;\n  height: 48px;\n  -o-object-fit: cover;\n     object-fit: cover;\n  border-radius: 50%;\n  border: 2px solid #ddd; }\n\n.team-thumb-placeholder {\n  display: inline-block;\n  width: 48px;\n  height: 48px;\n  line-height: 48px;\n  text-align: center;\n  background: #f4f4f4;\n  border-radius: 50%;\n  color: #aaa; }\n\n.status-badge {\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px; }\n\n.status-active {\n  background: #e8f5e9;\n  color: #2e7d32; }\n\n.status-inactive {\n  background: #fce4ec;\n  color: #c62828; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/teams/teams.component.scss
// module id = ../../../../../src-admin/app/components/teams/teams.component.scss
// module chunks = main